
import { Vue, Component, Prop } from 'vue-property-decorator'
import CustomWrapper from '@/components/CustomWrapper.vue'

@Component({
  name: 'c-quizz-media',
  components: { CustomWrapper }
})
export default class CQuizzMedia extends Vue {

  @Prop({ default: 'div'}) tag!: string

}
